import { V_FORM_ENUM } from "@/CommonDP/VForm/utils";
const COMPONENT_ENUM = {
  TYPE: "calc",
  LABEL: "计算控件"
};

export const schema = {
  group: V_FORM_ENUM.custom,
  type: COMPONENT_ENUM.TYPE,
  icon: "sub-form",
  label: COMPONENT_ENUM.LABEL,
  formItemFlag: true,
  component: require("./index.vue").default,
  options: {
    name: "",
    label: "",
    labelAlign: "",
    defaultValue: 0,
    placeholder: "",
    columnWidth: "200px",
    size: "",
    labelWidth: null,
    labelHidden: false,
    labelWrap: false,
    hidden: false,
    required: false,
    requiredHint: "",
    validation: "",
    validationHint: "",
    customClass: "",
    labelIconClass: null,
    labelIconPosition: "rear",
    labelTooltip: null,
    prefixIcon: "",
    suffixIcon: "",
    computationalFormula: [],
    jyhtPrecision: 0,
    thousandSeparator: false,
    displayPercent: false,
    displayUppercase: false,
    prefixText: "",
    suffixText: "",
    contentAlign: "left",
    setting: "",
    onCreated: "",
    onMounted: "",
    onChange: "",
    onInitAndUpdate: "",
    onFocus: "",
    onBlur: "",
    onValidate: ""
  },
  props() {
    return {
      setting: () => import("./setting.vue")
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ["value"]
    };
  },
  getSFC: () => {
    return "<div></div>";
  },
  zh: {
    [COMPONENT_ENUM.TYPE]: {
      label: "标签名称"
    }
  }
};
